var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.code)?_c('img',{attrs:{"src":_vm.code ? require(("@/assets/currencies/" + _vm.code + ".svg")) : ''}}):_c('currency-flag-default',{attrs:{"selected":_vm.selected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }